<div>
  <form class="sic-form" xpoFormInline>
    <mat-form-field floatLabel="always">
      <mat-label>SIC : </mat-label>
      <input #sicD matInput placeholder="Enter SIC" [value]="sicCode" required maxlength="3" type="string" />
    </mat-form-field>
    <button mat-flat-button xpoSmallButton xpoButton (click)="download(sicD.value)">Download</button>
  </form>
  <div style="white-space: pre-wrap"></div>
  <div>
    <form class="sic-form" xpoFormInline>
      <div style="white-space: pre-wrap"></div>
      <div *ngIf="env; else elseBlock" style="display: flex; flex-direction: column">
        <div style="text-decoration: underline">
          <a href="https://applicationdashboard.ltl.xpo.com/" target="_blank"
            ><strong>Application Availability Dashboard</strong></a
          >
        </div>
        <div style="white-space: pre-wrap"></div>
        <div style="text-decoration: underline">
          <a href="https://pdcs.ltl-xpo.com/" target="_blank"><strong>EDGE PDCS</strong></a>
        </div>
        <div style="white-space: pre-wrap"></div>
      </div>
      <ng-template #elseBlock>
        <div style="display: flex; flex-direction: column">
          <div style="text-decoration: underline">
            <a href="https://applicationdashboard.ltl.xpo.com/" target="_blank"
              ><strong>Application Availability Dashboard</strong></a
            >
          </div>
          <div style="white-space: pre-wrap"></div>
          <div style="text-decoration: underline">
            <a href="https://pdcs.dev-ltl-xpo.com/" target="_blank"><strong>EDGE PDCS</strong></a>
          </div>
          <div style="white-space: pre-wrap"></div>
        </div>
      </ng-template>
      <div style="white-space: pre-wrap"></div>
    </form>
  </div>
  <div>
    <form class="sic-form" xpoFormInline>
      <div style="display: flex; flex-direction: column">
        <div style="white-space: pre-wrap"></div>
        <div style="text-decoration: underline">
          <a href="https://xpologistics.sharepoint.com/sites/150/ttdd/BRP_Cert/SitePages/Home.aspx" target="_blank"
            ><strong>Visit L&D SharePoint for BRP</strong></a
          >
        </div>
        <div style="white-space: pre-wrap"></div>
        <div style="text-decoration: underline">
          <a
            href="https://xpologistics.sharepoint.com/:b:/s/XPOLearningandDevelopment/L&D Deliverables/IQBtlRP9dzTOR4h5070IChF1ARSkF90j1FPUVxXSEGjmUPU?e=2nUa1A"
            target="_blank"
            ><strong>Quick Sheet: EdgeBRP DockLiteMobile</strong></a
          >
        </div>
      </div>
    </form>
  </div>
</div>
